<template>
  <div class="api-params-container">
    <p>Parametrii API de date</p>
    <p class="text-center" :class="[syncData.color]" v-if="api_sync_status && api_sync_status.status">{{ syncData.text }}</p>
    <div class="filter_container">
      <div class="search_filters">
        <filter-header
          title="Selectați tractoare"
          :filterOptions="filters.machines"
          :selectedOptions="filters.machines"
          filterTextTemplate1="un tractor selectat"
          filterTextTemplate2=" tractoare selectate"
          swipeOption="machines"
          @swipeFilter="swipeFilter"
        />
      </div>

      <DxScrollView ref="scrollView">
        <div class="swipe-box" ref="swipeBox">
          <work-machine-selector
            v-if="showWorkMachineSelector"
            @onSelectionChanged="onWorkMachineSelectorChanged"
            :api-config="apiConfig"
            :source-type="sourceType"
          />
        </div>
      </DxScrollView>

      <b-form-select v-model="season_id" class="form-control" @change="handleSeasonChange" :options="seasonList"></b-form-select>
    </div>
    <label>De la</label>
    <div class="datetime-container">
      <dx-date-box v-model="filters.dateFrom" type="date" display-format="yyyy-MM-dd" picker-type="rollers" />
      <dx-date-box v-model="filters.timeFrom" type="time" display-format="HH:mm" picker-type="rollers" />
    </div>
    <label>Până la</label>
    <div class="datetime-container">
      <dx-date-box v-model="filters.dateTo" type="date" display-format="yyyy-MM-dd" picker-type="rollers" />
      <dx-date-box v-model="filters.timeTo" type="time" display-format="HH:mm" picker-type="rollers" />
    </div>

    <div class="dialog-footer-buttons">
      <b-button :disabled="waiting_for_api_response" class="continue_button" variant="outline-secondary" size="sm" pill @click="applyFilters">Aplică</b-button>
    </div>
    <toast-message ref="toastMessage"></toast-message>
  </div>
</template>

<script>
import DxDateBox from "devextreme-vue/date-box";
import FilterHeader from "@/components/Mobile/filterHeader.vue";
import { DxScrollView } from "devextreme-vue/scroll-view";
import WorkMachineSelector from "@/pages/works/applyArticles/partials/WorkApiDialog/WorkMachineSelector.vue";
import * as apiTypes from "@/helpers/apiTypes";
import { mapActions, mapGetters } from "vuex";
import { buildDefaultDropdownList, errorMessageList, handlePromiseException } from "@/helpers/common";
import { types } from "@/helpers/ImportTypes";
import { sourceTypes } from "@/helpers/ImportSourceTypes";
import ToastMessage from "@/components/Mobile/toastMessage.vue";
import moment from "moment";
import * as apiStatus from "@/helpers/apiStatus";
import { syncData } from "@/helpers/apiStatus";

export default {
  props: ["sourceType", "show"],
  components: {
    ToastMessage,
    WorkMachineSelector,
    FilterHeader,
    DxDateBox,
    DxScrollView,
  },
  data() {
    return {
      filters: {
        machines: [],
        season_id: null,
        dateFrom: new Date(),
        timeFrom: moment().subtract(1, "hours").toDate(),
        dateTo: new Date(),
        timeTo: new Date(),
      },
      season_sync_key: "SYNC_SEASONS",
      season_id: null,
      showWorkMachineSelector: false,
      api_sync_status: this.tracktorApiSyncStatus ?? {},
      waiting_for_api_response: false,
    };
  },
  computed: {
    ...mapGetters({
      importConfigurations: "importConfig/importConfigurations",
      tracktorApiSyncStatus: "importConfig/tracktorApiSyncStatus",
      seasons: "seasons/seasons",
    }),
    apiConfig() {
      return this.importConfigurations?.find(
        (config) =>
          config.import_type === "SGPS_DASC_IMPORT" &&
          config.is_active === 1 &&
          config.source_type === "API_IMPORT" &&
          config.source_config_uuid
      );
    },
    seasonList() {
      let seasons = this.seasons ?? [];

      //filter for remote usage if set
      if (this.sourceType === "remote") {
        seasons = this.seasons.filter((item) => {
          return Boolean(item.remote_id);
        });

        if (seasons.length === 0 && this.seasons.length > 0) {
          seasons.push({
            uuid: this.season_sync_key,
            name: "-" + this.$t("sync_seasons") + "-",
          });
        }
      }

      return buildDefaultDropdownList(seasons, null, {
        value: null,
        text: "-" + this.$t("select_season") + "-",
        subtext: null,
      });
    },
    syncData() {
      return syncData(this, this.api_sync_status);
    },
  },
  methods: {
    ...mapActions({
      importApiCall: "importConfig/importApiCall",
      getImportConfigurations: "importConfig/getImportConfigurations",
      getSeasons: "seasons/getSeasons",
      syncTracktorApiProjects: "importConfig/syncTracktorApiProjects",
      getTracktorApiSyncStatus: "importConfig/getTracktorApiSyncStatus",
    }),
    swipeFilter(filter) {
      this.showWorkMachineSelector = !this.showWorkMachineSelector;
    },
    applyFilters() {
      if (this.waiting_for_api_response) return;

      this.filters.api_type = apiTypes.TRACKTOR_API_DA_TYPE;
      if (this.filters.machines.length > 0 && this.filters.season_id && this.filters.dateFrom && this.filters.dateTo) {
        this.filters.season_id = this.seasons.find((s) => s.uuid === this.season_id)?.remote_id;
        this.filters.machine_ids = this.filters.machines.map((machine) => machine.remote_id);
        this.filters.datetime_from =
          moment(this.filters.dateFrom).format("YYYY-MM-DD") + " " + moment(this.filters.timeFrom).format("HH:mm");
        this.filters.datetime_to = moment(this.filters.dateTo).format("YYYY-MM-DD") + " " + moment(this.filters.timeTo).format("HH:mm");
        this.sendApiImportRequest();
      } else {
        this.showError(this.$t("fill_out_error"));
      }
    },
    showError(message) {
      this.$refs.toastMessage.showError(message);
    },
    showSuccess(message) {
      this.$refs.toastMessage.showSuccess(message);
    },
    onWorkMachineSelectorChanged(selectedValues) {
      this.$set(this.filters, "machines", selectedValues);
    },
    syncSeasons() {
      const vm = this;
      vm.syncTracktorApiProjects({
        import_configuration_uuid: this.apiConfig["uuid"] ?? null,
      }).then((projects) => {
        vm.getSeasons().then((resp) => {
          vm.season_id = null;
        });
      });
    },
    handleSeasonChange(value) {
      this.filters.season_id = value;
    },
    sendApiImportRequest() {
      //not ready, retrieves work list data
      if (!this.apiConfig || !this.apiConfig.uuid) {
        this.showError(this.$t("tools.import.api_import_required_error"));
        return;
      }

      this.waiting_for_api_response = true;

      const payload = {
        ...this.filters,
        ...{
          import_configuration_uuid: this.apiConfig.uuid,
        },
      };

      let vm = this;
      this.importApiCall(payload)
        .then((response) => {
          this.showSuccess(response.message);
          vm.$emit("onImportRequestSent", response);
        })
        .catch((e) => {
          handlePromiseException(vm, e, this.showError);
        })
        .finally(() => {
          this.waiting_for_api_response = false;
        });
    },
    handleSyncData() {
      if (this.api_sync_status && this.api_sync_status.status == apiStatus.IMPORTED) {
        const lastDateTime = moment(this.api_sync_status.datetime_to);
        /*this.filters.dateFrom = lastDateTime.format('YYYY-MM-DD');
        this.filters.timeFrom = lastDateTime.format('HH:mm');
        this.filters.dateTo = lastDateTime.format('YYYY-MM-DD');
        this.filters.timeTo = lastDateTime.add(2, 'hour').format('HH:mm');
         */

        this.filters.dateFrom = moment(lastDateTime.format("YYYY-MM-DD")).toDate();
        this.filters.timeFrom = moment(lastDateTime.format("YYYY-MM-DD") + " " + lastDateTime.add(1, "minute").format("HH:mm")).toDate();
        this.filters.dateTo = moment(lastDateTime.format("YYYY-MM-DD")).toDate();
        this.filters.timeTo = moment(lastDateTime.format("YYYY-MM-DD") + " " + lastDateTime.add(2, "hour").format("HH:mm")).toDate();

        /*
        if (this.seasons) {
          this.filters.season_id = this.api_sync_status.params.season_id;
          this.season_id = this.api_sync_status.params.season_id;
        }*/
      }
    },
  },
  mounted() {
    this.getImportConfigurations({
      import_type: types.SGPS_DASC_IMPORT.id,
      source_type: sourceTypes.API_IMPORT.id,
    });
  },
  watch: {
    season_id: {
      handler: function (newVal) {
        if (newVal === this.season_sync_key) {
          this.syncSeasons();
        }
      },
      deep: true,
      immediate: true,
    },
    tracktorApiSyncStatus: {
      handler: function (newVal) {
        this.api_sync_status = newVal;
        this.handleSyncData();
      },
      deep: true,
    },
    show: function (newVal) {
      if (newVal) {
        this.getTracktorApiSyncStatus();
      }
    },
  },
};
</script>

<style>
@import "devextreme/dist/css/dx.light.css";
@import "@/assets/scss/digitalAgenda/daFilters.scss";

.datetime-container {
  display: flex;
}

.api-params-container {
  label {
    padding-top: 16px;
    padding-bottom: 2px;
    font-weight: bold;
  }

  .filter_container {
    height: auto !important;

    .main_filter_row {
      border-bottom: none !important;

      .main_filter_selected {
        padding-top: 10px;
      }
    }
    .search_filters {
      margin-left: 0px !important;
    }

    .row_container {
      .checkbox_row {
        align-items: baseline;
        padding-top: 5px !important;
      }
    }
  }

  .dialog-footer-buttons {
    display: flex;
    justify-content: center;
  }

  .swipe-box {
    padding-top: 15px;
  }
}
</style>
